import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  Lookup,
} from "devextreme-react/data-grid";
import { FillFilters, GetDatePartOnly, GetFormatedDateWithTime } from '../../../../common/Utils'
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];






const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "8647A7D8-A36E-424E-B80C-00E64ECEF49D";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const initialFormFields = {
        RecordNumber: '',
        DateIntroducedForm: '',
        DateIntroducedTo: '',
        DateAvailableFrom: '',
        DateAvailableTo: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const statuses = [{ id: 'A', text: 'Active' }, { id: 'I', text: 'Inactive' }];
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].RowId;
        }
        else {
            rowId.current = '';
        }

        setIsEditButtonDisabled(!isEditButtonDisabled);
    };

    const handelEditClick = () => {
        const buttonUrl = "/wm/codes/edit-sublot?id=" + rowId.current;
    history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();
        const { DateIntroducedForm, DateIntroducedTo,DateAvailableFrom,DateAvailableTo, ...filteredFormFields } = formFields;
        const filters = FillFilters(filteredFormFields);
        datasource.filter(filters);
        setResultData(datasource);
    };
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
    }
    useEffect(() => {
        if (formFields.RecordNumber === '' 
        )
            setResultData(loadDatasource);
    }, [formFields]);

    const handleFormLoad = useCallback(() => {
       // loadLookupFromStaticData(formRefs, "STATUS", statuses);

    }, []);
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'text');
            if (formFields[name])
                formRefs.current[name].instance().option('value', formFields[name]);
        }

    };

    const handleFieldChange = useCallback((name, value) => {
        // console.log(name, value);
    }, []);


    const loadDatasource = () => {
        var url = "wm/SubLot/GetSublotListingData";
        let store = createStore({
            key: 'RowId',
            loadParams: {
                DateIntroducedForm :GetFormatedDateWithTime(formFields.DateIntroducedForm),
                DateIntroducedTo :GetFormatedDateWithTime(formFields.DateIntroducedTo),
                DateAvailableFrom :GetFormatedDateWithTime(formFields.DateAvailableFrom),
                DateAvailableTo :GetFormatedDateWithTime(formFields.DateAvailableTo)
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    }
    const [resultData, setResultData] = useState(null);


    const handleValueChanged = (e) => {
        console.log(e)
    }

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Sublot Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='1E58A628-DCE1-43E6-A46A-F6D1B4D51BFF'
                                layoutName='WMItemDataEntrySearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <Paging defaultPageSize={10} />
                            <Pager
                                visible={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={allowedPageSizes}
                                showNavigationButtons={true}
                            />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Column visible={false} dataType="string" caption='ID' dataField='RowId'  />
                            <Column visible={false} dataType="string" caption='Created Date' dataField='Creationdatetime'  />
                            <Column visible={false} dataType="string" caption='Created By' dataField='Creationuserid'  />
                            <Column visible={false}  dataType="string" caption='Lastupdated' dataField='Lastupdatedatetime'  />
                            <Column visible={false} dataType="string" caption='Last Updated By' dataField='Lastupdateuserid'  />
                            <Column dataType="string" caption='Record#' dataField='RecordNumber'  />
                            <Column  dataType="string" caption='ItemCode' dataField='ItemCode' />
                            <Column  dataType="string" caption='LotCode' dataField='LotCode' />
                            <Column  dataType="string" caption='SubLot' dataField='SublotCode' />
                            <Column  dataType="string" caption='Description- 1' dataField='Description1' />
                            <Column visible={false} dataType="string" caption='Description- 2' dataField='Description2' />
                            <Column visible={false} dataType="string" caption='First Receipt' dataField='Intransactionnumber' />
                            
                            <Column  dataType="string" caption='Status' dataField='Status' />
                            <Column visible={false} caption='Introduced Date' dataType="date" format="MM/dd/yyyy" dataField='DateIntroduced' />
                            <Column visible={false} caption='Available Date' dataType="date" format="MM/dd/yyyy" dataField='DateAvailable' />
                            <Column visible={false} caption='Expiration Date' dataType="date" format="MM/dd/yyyy" dataField='DateExpiration' />
                            <Column visible={false} dataType="string" caption='Def Location' dataField='LocationCode' />
                            <Column visible={false} dataType="string" caption='Recurring Flag' dataField='Recurringstorage' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Size 1' dataField='Size1' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Size 2' dataField='Size2' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='On Hand' dataField='OnHand' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Unit price' dataField='Unitprice' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Pending Rec' dataField='InOrdered' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Pending Ship' dataField='OutOrdered' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Future Rec' dataField='InFuture' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Future Ship' dataField='OutFuture' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='In Receiving' dataField='InReceiving' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='In Shipping' dataField='OutShipped' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Unavailable' dataField='OutUnavailable' />
                            <Column  dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Available' dataField='Available' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='Net Available' dataField='NetAvailable' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='BO-Receiving' dataField='BOReciving' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} caption='BO-Shipping' dataField='BOShipped' />
                            <Column visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 4, useGrouping: true }} caption='Unit Tare Wt' dataField='UnitTrWeight' />
                            <Column visible={false} dataType="string" caption='Description- 1' dataField='Alternateid' />
                            <Column visible={false} dataType="string" caption="Code- 1" dataField="Userdefinedcode1" />
                            <Column visible={false} dataType="string" caption="Code- 2" dataField="Userdefinedcode2" />
                            <Column visible={false} dataType="string" caption="Code- 3" dataField="Userdefinedcode3" />
                            <Column visible={false} dataType="string" caption="Code- 4" dataField="Userdefinedcode4" />
                            <Column visible={false} dataType="string" caption="Code- 5" dataField="Userdefinedcode5" />
                            <Column visible={false} dataType="string" caption="Code- 6" dataField="Userdefinedcode6" />
                            <Column visible={false} dataType="string" caption="Code- 7" dataField="Userdefinedcode7" />
                            <Column visible={false} dataType="string" caption="Code- 8" dataField="Userdefinedcode8" />
                            <Column visible={false} dataType="string" caption="Code- 9" dataField="Userdefinedcode9" />
                            <Column visible={false} dataType="string" caption="Code- 10" dataField="Userdefinedcode10" />

                            <Column visible={false} dataType="string" caption="Reference- 1" dataField="Userdefinedreference1" />
                            <Column visible={false} dataType="string" caption="Reference- 2" dataField="Userdefinedreference2" />
                            <Column visible={false} dataType="string" caption="Reference- 3" dataField="Userdefinedreference3" />
                            <Column visible={false} dataType="string" caption="Reference- 4" dataField="Userdefinedreference4" />
                            <Column visible={false} dataType="string" caption="Reference- 5" dataField="Userdefinedreference5" />
                            <Column visible={false} dataType="string" caption="Reference- 6" dataField="Userdefinedreference6" />
                            <Column visible={false} dataType="string" caption="Reference- 7" dataField="Userdefinedreference7" />
                            <Column visible={false} dataType="string" caption="Reference- 8" dataField="Userdefinedreference8" />
                            <Column visible={false} dataType="string" caption="Reference- 9" dataField="Userdefinedreference9" />
                            <Column visible={false} dataType="string" caption="Reference- 10" dataField="Userdefinedreference10" />

                            <Column visible={false} dataType="date" caption="Date- 1" dataField="Userdefineddate1" />
                            <Column visible={false} dataType="date" caption="Date- 2" dataField="Userdefineddate2" />
                            <Column visible={false} dataType="date" caption="Date- 3" dataField="Userdefineddate3" />
                            <Column visible={false} dataType="date" caption="Date- 4" dataField="Userdefineddate4" />
                            <Column visible={false} dataType="date" caption="Date- 5" dataField="Userdefineddate5" />
                            <Column visible={false} dataType="date" caption="Date- 6" dataField="Userdefineddate6" />
                            <Column visible={false} dataType="date" caption="Date- 7" dataField="Userdefineddate7" />
                            <Column visible={false} dataType="date" caption="Date- 8" dataField="Userdefineddate8" />
                            <Column visible={false} dataType="date" caption="Date- 9" dataField="Userdefineddate9" />
                            <Column visible={false} dataType="date" caption="Date- 10" dataField="Userdefineddate10" />
                            <Column visible={false} dataType="number" caption="Quantity- 1" dataField="Userdefinedquantity1" />
                            <Column visible={false} dataType="number" caption="Quantity- 2" dataField="Userdefinedquantity2" />
                            <Column visible={false} dataType="number" caption="Quantity- 3" dataField="Userdefinedquantity3" />
                            <Column visible={false} dataType="number" caption="Quantity- 4" dataField="Userdefinedquantity4" />
                            <Column visible={false} dataType="number" caption="Quantity- 5" dataField="Userdefinedquantity5" />
                            <Column visible={false} dataType="number" caption="Quantity- 6" dataField="Userdefinedquantity6" />
                            <Column visible={false} dataType="number" caption="Quantity- 7" dataField="Userdefinedquantity7" />
                            <Column visible={false} dataType="number" caption="Quantity- 8" dataField="Userdefinedquantity8" />
                            <Column visible={false} dataType="number" caption="Quantity- 9" dataField="Userdefinedquantity9" />
                            <Column visible={false} dataType="number" caption="Quantity- 10" dataField="Userdefinedquantity10" />


                            <GridToolbar>
                                <GridToolbarItem location="before">
                                    <Button
                                        disabled={isEditButtonDisabled}
                                        onClick={handelEditClick}
                                        type="default"
                                        text="Edit"
                                    ></Button>
                                </GridToolbarItem>
                                <GridToolbarItem location="before">
                                    <div>
                                        <Link to="/wm/codes/add-sublot">
                                            <Button
                                                type="default"
                                                className="gridTopButton"
                                                text="Create"
                                            ></Button>
                                        </Link>
                                    </div>
                                </GridToolbarItem>
                                 <GridToolbarItem location="after">
                                 <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(List);